import { DELIVERY_METHODS_DICTIONARY } from "@features/checkout/types";
import type { ShippingPrice } from "@components/commerce/order/types";

export function getDeliveryMethodKey(key: string): string {
    const hostName = process.env.NEXT_PUBLIC_HOSTNAME;
    return (
        DELIVERY_METHODS_DICTIONARY[hostName]?.find((entry) => entry.key === key)?.marketKey ?? key
    );
}

export const findClickAndCollect = (deliveryMethods: ShippingPrice[]) => {
    return (
        deliveryMethods?.find((method) => method.key === "CC") || {
            key: "CC",
            name: "",
        }
    );
};

export const findHomeDelivery = (deliveryMethods: ShippingPrice[]) => {
    return deliveryMethods?.find((method) => {
        return method.orderType === "HD";
    });
};
